import type { ClientListItem } from '@metapic-apps/shared'

import type { CreatorListItemType } from './creators.types'

import type { AdvertiserGroupType } from '@/lib/types/advertiser-groups.types'
import type { AdvertiserListItemType } from '@/lib/types/advertiser.types'
import { type SocialItemEnum } from '@/lib/types/socials.types'

export type FilterValueType =
  | number
  | string
  | boolean
  | undefined
  | null
  | { id: number; [key: string]: unknown }
  | string[]
  | number[]

export type CommonFilterType = Record<string, FilterValueType>

export type ListItemsType = { label: string; value: string }[]

export type ProcessableServerImageType = {
  key: string
  base_url: string
  content_type?: string
  url?: string
}

/**
 * See https://docs.metapic.dev/engineering/image-processing
 */
export type ProcessableImageType = {
  key?: string
  baseUrl?: string
  contentType?: string
  url?: string
}

export type AssetType = {
  url: string
  type: 'image' | 'video'
  baseUrl?: string
  key?: string
}

type legacyFilterType = {
  sort?: string
}

export type FilterType = {
  query?: string
  advertiserGroup?: Pick<AdvertiserGroupType, 'id' | 'name'>
  advertiser?: Pick<AdvertiserListItemType, 'id' | 'label'>
  advertiserGroupId?: number
  client?: Pick<ClientListItem, 'id' | 'name'>
  status?: string
  statuses?: string[]
  createdBy?: number
  createdByMe?: boolean
  include?: string[]
  page?: number
  size?: number | string
  limit?: number | string
  sortBy?: string
  targetUserId?: number
  creator?: Pick<CreatorListItemType, 'id' | 'username'>
  campaign?: { id: number; name: string }
  dateFrom?: string
  dateTo?: string
  startDate?: string
  endDate?: string
  source?: string
  orId?: number
} & legacyFilterType

export type MoneyServerType = {
  amount: string
  currency: string
}

export type MoneyType = {
  amount: number
  currency: string
}

export enum TargetItemEnum {
  User = 'user',
  UserTag = 'user_tag',
  Client = 'client',
  RevenueTier = 'revenue_tier_id',
  Segment = 'segment',
}
export type TargetItemType = { type: TargetItemEnum; id: number | string; label: string }

export type RevenueTierServerType = {
  id: number
  created_at: string
  updated_at: string
  client_id: number
  revenue_share: string
  instagram_revenue_share: string
  name: string
  validates_users: number
}

export type RevenueTierType = {
  id: number
  name: string
  revenueShare: string
  instagramRevenueShare: string
  clientId: number
  validatesUsers: number
  createdAt: string
  updatedAt: string
}

export type SocialItemServerType = {
  id: string
  type: SocialItemEnum
  identifier: string
  created_at: string
  updated_at: string
  followers: number | null
}
